import { useQuery } from '@tanstack/vue-query'
import { useHttp } from '@/shared/lib'

const useLoadTree = (parent_id?: number) => {
  const http = useHttp()
  const url = parent_id ? `/objects/tree?parent_id=${parent_id}` : '/objects/tree'

  return useQuery({
    queryKey: ['load_tree', parent_id || 'default'],
    queryFn: () => http.get(url),
    retry: false,
    enabled: false,
  })
}

export { useLoadTree }
